import { Button } from "components/buttons/button";
import { Spinner } from "components/spinner";
import { ButtonHTMLAttributes, DetailedHTMLProps, FC } from "react";
import { useFormContext } from "react-hook-form";

type Props = {} & Omit<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  "disabled" | "onClick" | "type"
>;
export const FormSubmit: FC<Props> = ({ children, className, ...rest }) => {
  const {
    formState: { isValid, isSubmitting },
  } = useFormContext();

  return (
    <button
      type='submit'
      disabled={!isValid || isSubmitting}
      {...rest}
      className={`inline-flex space-x-3 ${className}`}>
      {isSubmitting ? (
        <span className='my-auto'>
          <Spinner size={4} />
        </span>
      ) : null}
      <span>{children}</span>
    </button>
  );
};
